document.addEventListener('DOMContentLoaded', function() {
  let header = document.querySelector('header');

  let adminBar = document.querySelector('#wpadminbar');
  let adminBarHeight = 0;

  // Function to get the current header height (including sticky state)
  const getHeaderHeight = () => {
    if (adminBar) {
      adminBarHeight = adminBar.offsetHeight;
    }

    return header.offsetHeight + adminBarHeight;
  };

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const currentPageUrl = window.location.href.split('#')[0]; // Get the current page URL without the hash
      const anchorUrl = this.href.split('#')[0]; // Get the anchor's base URL without the hash

      // Check if the anchor is an internal link (same page)
      if (currentPageUrl === anchorUrl) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Get the current header height, including sticky state
          const headerHeight = getHeaderHeight();

          // Calculate the top position of the target element relative to the viewport
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

          // Subtract the fixed header height to offset the position
          const offsetPosition = elementPosition - headerHeight;
          console.log(offsetPosition);
          console.log(headerHeight);
          console.log(elementPosition);
          // Smooth scroll to the calculated position
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});
